/*
 ** Manter esse arquivo organizado por ordem alfabética
 */
export enum FeatureFlags {
  CS_CHAT = 'CS_CHAT',
  TRADE_3_0 = 'TRADE_3_0',
  DISABLE_WARREN_BUILDER = 'DISABLE_WARREN_BUILDER',
  PLATFORM_MAINTENANCE = 'br.com.warren.foundation.platform-maintenance',
  IS_PARTNER_WEB_DISABLED = 'br.com.warren.disable-partner-web',
  REGULATORY_UPDATE_BUREAU = 'br.com.warren.experience.regulatory-update-bureau',
  ENABLE_FATCA_IN_REGULATORY_UPDATE = 'br.com.warren.experience.enable-fatca-in-regulatory-update',
  ENABLE_FIXED_INCOME_COMMISSION = 'br.com.warren.fixed-income-comission',
  ENABLE_NEW_HOME_INVESTMENT_FLOW = 'br.com.warren.experience.enable-new-home-investment-flow',
  ENABLE_BFF_BANKING_MIGRATION = 'br.com.warren.experience.enable-bff-banking-migration',
  ENABLE_ON_GOING_REDEMPTIONS = 'br.com.warren.on-going-redemptions',
  ENABLE_BFF_INSTRUMENTS_MIGRATION = 'br.com.warren.experience.enable-bff-instruments-migration',
  ENABLE_BFF_PORTFOLIO_MIGRATION = 'br.com.warren.experience.enable-new-portfolios-bff'
}
